<template>
  <div class="bx-gtin">
    <div class="grid-row">
      <div class="col-xs-12 col-sm-7">
        <!-- Wrap the list in a scrollable container -->
        <div class="scrollable-list">
          <ul class="features">
            <!-- Your v-for loop here -->
            <li v-for="(field, fieldName) in filteredFields" :key="fieldName">
              <div class="label">
                {{ $t(`lang.bx_gtin.${fieldName}`) }}
              </div>
              <div class="value">
                {{ field }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-xs-12 col-sm-5 man-img">
        <!-- Use a conditional (v-if) to check if gtin.image is defined -->
        <img
          v-if="gtin.image"
          :src="gtin.image"
          :alt="gtin.code"
          class="responsive-image"
        />
        <!-- If gtin.image is not defined, display a default image -->
        <img
          v-else
          src="https://static.vecteezy.com/system/resources/previews/005/337/799/original/icon-image-not-found-free-vector.jpg"
          alt="Default Image"
          class="responsive-image"
        />
      </div>
    </div>
  </div>
</template>


<style scoped>
/* Apply styles to make the scrollable container smaller */
.scrollable-list {
  width: 90vh;
  max-height: 70vh; /* Adjust the maximum height as needed */
  overflow-y: auto; /* Enable vertical scrolling */
}

/* Apply styles to resize the image */
.responsive-image {
  max-width: 150%; /* Set maximum width to 100% of the container */
  max-height: 140vh; /* Set maximum height to 100% of the viewport height */
  object-fit: contain; /* Maintain aspect ratio and fit within the dimensions */
}
</style>

<script>
export default {
  name: "bx-gtin",
  props: {
    gtin: {
      type: Object,
      required: true
    }
  },
  computed: {
    filteredFields() {
      // Create a copy of gtin without the "image" field
      const filteredGtin = { ...this.gtin };
      delete filteredGtin.image;

      // Filter out fields with empty or falsy values
      for (const key in filteredGtin) {
        if (!filteredGtin[key]) {
          delete filteredGtin[key];
        }
      }

      return filteredGtin;
    },
  }
};
</script>
